import React, { useContext, useEffect } from 'react';
import { CheckboxGroup, Checkbox } from '@lemon8/design';
import { FieldProps } from '../type/form';
import { FormContext, FormItem } from '../../form';

import './style.scss';

export function FormCheckbox(props: FieldProps) {
  const {
    name,
    label,
    tip,
    className = 'form-checkbox',
    required,
    group,
    rules,
    options = [],
    defaultValue = [],
  } = props;
  const { state, dispatch } = useContext(FormContext);
  useEffect(() => {
    dispatch({ name, type: 'change', payload: defaultValue });
  }, []);
  const handleChange = (_value: (string | number)[]) => {
    dispatch({ name, type: 'change', payload: _value });
  };
  return (
    <FormItem
      {...{
        name,
        label,
        tip,
        className,
        required,
        rules,
        group,
      }}
      className="formitem-checkbox-container"
    >
      <CheckboxGroup defaultValue={defaultValue as any} name={name} onChange={handleChange}>
        {/* @ts-ignore */}
        {options.map((item, index) => {
          const { values } = state;
          const checked = values[name]?.includes(item.symbol);
          return (
            // @ts-ignore
            <Checkbox
              className="checkbox-item"
              type="normal"
              disabled={false}
              align="left"
              certainHeight={false}
              value={item.symbol}
              key={index}
              checked={checked}
            >
              <div>{item.label}</div>
            </Checkbox>
          );
        })}
      </CheckboxGroup>
    </FormItem>
  );
}
